export const AMPLITUDE_KEY = 'cd80b9d1ba0f68979987279bdaaa80f4';
export const AMPLIRUDE_KEY_B2B = 'a06e10b51308bf73400af37743c0f67f';
